import { AccessUserResponse } from '@moovly/clients/lib/resources/access/access.interfaces';
import { useSelector } from 'react-redux';
import { RootState } from '../store/rootStore';

const useAccess = (): AccessUserResponse | null => {
  return useSelector((state: RootState) => state.accesss.userAccess.data);
};

export default useAccess;
